var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Quill from 'quill';
var embed = Quill.import('blots/embed');
var BlockMessage = /** @class */ (function (_super) {
    __extends(BlockMessage, _super);
    function BlockMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlockMessage.create = function (text) {
        var node = _super.create.call(this);
        node.innerText = text;
        node.classList.add('font-semibold', 'mb-md', 'whitespace-normal');
        return node;
    };
    BlockMessage.blotName = 'BlockMessage';
    BlockMessage.className = 'block-message';
    BlockMessage.tagName = 'div';
    return BlockMessage;
}(embed));
export { BlockMessage };
